// extracted by mini-css-extract-plugin
export var button = "InputGroup-module--button--92d7f";
export var column = "InputGroup-module--column--a2175";
export var fadeInAnimation = "InputGroup-module--fadeInAnimation--2d7c3";
export var inputGroup = "InputGroup-module--inputGroup--c39a7";
export var tile = "InputGroup-module--tile--3656d";